import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
//import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
//import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
//import { Datetime } from 'vue-datetime'
//import 'vue-datetime/dist/vue-datetime.css'

export default {
	name: 'shipmentdetails',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading,
		DatePicker
		//VueCtkDateTimePicker,
		//Datetime
	},
	props: [],
	data() {
		return {
			countOfShipment:'',
			showShipmentDetailsModal:false,
			manifestName:'',
			manifestId:'',
			ManifestDatalist:[
				{
	        id: 1,
	        text: "InBound"
	      }, {
	        value: 2,
	        text: "APIManifest"
	      },{
	        value: 3,
	        text: "ShipmentManifest"
	      },
				{
					value: 4,
					text: "SupplierManifest"
				},
				{
					value: 5,
					text: "SecondaryInScan"
				}
			],
				SQSDatalist:[
					{
		        value: 1,
		        text: "Yes"
		      },
					{
		        value: 2,
		        text: "No"
		      }],
					SQSData:{
						text: '',
						value: '',
					},
			shipmentno: '',
			destinationhublist: [],
			manifestData:{
				text: '',
				value: ''
			},

			hubLoading: '',
			SQSName:'',
			shipmentDetailsList: [],
			username: '',
			useremail: '',
			uasertype: '',
			hubid: '',
			fromdate: '',
			todate: '',
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
			if (val && val > 0) {
				return Number(parseFloat(val).toFixed(2));
			} else {
				return 0;
			}
		},
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.uasertype = userdetail[0].utype;
		this.username = userdetail[0].FirstName;
		this.useremail = userdetail[0].email
	},
	methods: {
		SelectManifestData(obj){
			this.manifestData=obj
			this.manifestName=obj.text
			//this.ManifestId=obj.value
		},
		SelectSQSData(objdata)
		{	this.SQSData=objdata
			this.SQSName=objdata.text
			//this.SQSId=objdata.value

		},
		//for filter schedule list


		dateFormat(date) {
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		getShipmentList() {
			this.showShipmentDetailsModal=false,
			this.input = ({
				"DataFromType": this.manifestName,
				"PushToSQS":this.SQSName,
				"FromDate":this.dateFormat(this.fromdate),
				"ToDate":this.dateFormat(this.todate)
			})
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'pushShipmentDataForOldSystem',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {

						this.shipmentDetailsList = result.data.ShipmentData;
						this.countOfShipment=result.data.TotalCount;
						this.$alertify.success(result.data.ReturnMessage)

						this.showShipmentDetailsModal=true;
					} else {
						this.pageCount = 0
						this.shipmentDetailsList = [];
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					console.error(error)

				})
		},

		resetflt() {
			this.countOfShipment='',
			this.shipmentDetailsList = [],
				this.fromdate = '',
				this.todate = '',
				this.SQSName='',
				this.shipmentno = '',
				this.manifestName='',
				this.SQSData={
						text: '',
						value: '',
					},
				this.manifestData= {
					text: '',
					value: '',
				},
				this.showShipmentDetailsModal=false,
				this.fromdate = '',
				this.todate = '',
			this.$validator.reset()
		},
		onSubmitflt: function() {

			var self = this
			this.$validator.validateAll().then((result) => {
			 if (!result) {
					return false
				} else {
					console.log(1);
					this.getShipmentList();
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/Sorter/pushShipmentDataOldSystem/pushShipmentDataOldSystem.js